import { render, staticRenderFns } from "./SecurePayDepositFrame.vue?vue&type=template&id=7b9085b5&scoped=true&"
import script from "./SecurePayDepositFrame.vue?vue&type=script&lang=js&"
export * from "./SecurePayDepositFrame.vue?vue&type=script&lang=js&"
import style0 from "./SecurePayDepositFrame.vue?vue&type=style&index=0&id=7b9085b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9085b5",
  null
  
)

export default component.exports